module.exports = __webpack_public_path__ + "static/media/legenda-c.7ec5f796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/legenda-c.png
// module id = 893
// module chunks = 0